import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import { LoaderIcon } from '@mentimeter/ragnar-visuals';
import { EmptyState } from './EmptyState';
import { Question } from './Question';

export const qfaDisplayTestIds = {
  slideTitle: 'qfaDisplayTestIds_slideTitle',
};

export const Display = () => {
  const { useTranslate, useQfa, useSeries } = usePresentationContext();
  const translate = useTranslate();
  const { qfa_intercom_enabled, qfa_moderation_enabled } = useSeries();
  const {
    initialized,
    loading,
    error,
    activeId,
    questions,
    ids: { all },
    askedOnSlide,
  } = useQfa();
  const activeQuestion = questions && activeId ? questions[activeId] : null;

  if (loading && !initialized) return <LoaderIcon size={3} />;
  if (error) return <EmptyState title={translate('message.unknown_error')} />;

  const allQ = all && all.items;
  const currentIndex = allQ.findIndex((i) => i === activeId);

  if (!activeId || !activeQuestion) {
    return (
      <EmptyState
        title={
          qfa_moderation_enabled
            ? translate('qfa.waiting')
            : translate('qfa.no_questions_audience')
        }
        description={
          qfa_moderation_enabled
            ? translate('qfa.waiting_description')
            : translate('qfa.incoming_questions')
        }
      />
    );
  }

  return (
    <Question
      id={activeQuestion.id}
      qfaQuestion={activeQuestion.question ?? ''}
      numberOfUpvotes={activeQuestion.upvotes ?? 0}
      intercomEnabled={qfa_intercom_enabled}
      currentIndex={currentIndex}
      totalNrOfQuestions={all.total}
      isAnswered={activeQuestion.bucket === 'archived'}
      loading={loading}
      askedOnSlideTitle={askedOnSlide}
      displayName={activeQuestion.display_name}
    />
  );
};
